import type { NodeApi, TreeApi } from "@hogartrabe/react-arborist-vrh";
import type { Node } from "interfaces/schemas";
import { walkTree } from "utils/treeUtils/walkTree";

export const collapseLevel = (
  openMap: Record<string, boolean> | null,
  treeApi: TreeApi<Node>,
) => {
  if (openMap === null) {
    throw new Error("Open map is not initialized. Cannot collapse level.");
  }
  if (!treeApi) {
    throw new Error("Tree API is not available. Cannot collapse level.");
  }
  const rootNode = treeApi.root.children?.[0];
  if (!rootNode) {
    throw new Error("Root node is missing. Cannot collapse level.");
  }
  const newOpenMap = { ...openMap };
  const nodesToClose = new Set<NodeApi<Node>>();

  let currentMaxLevel = 0;

  walkTree({
    node: rootNode,
    childAccessor: (node) => node.children,
    skipChildren: (node) => !node.isOpen,
    callback: (node) => {
      if (
        node.isOpen &&
        (node.children?.length ?? 0) > 0 &&
        node.level >= currentMaxLevel
      ) {
        if (node.level === currentMaxLevel) {
          nodesToClose.add(node);
        } else {
          currentMaxLevel = node.level;
          nodesToClose.clear();
          nodesToClose.add(node);
        }
      }
    },
  });
  if (currentMaxLevel > 0) {
    nodesToClose.forEach((node) => {
      node.close();
      newOpenMap[node.id] = false;
    });
  }
  return newOpenMap;
};
